export default __webpack_public_path__ + "static/media/arrrow-down.9bd02e83.svg";